import IdentifyCorrectSentence from "../../components/ClassOne/English/IdentifyCorrectSentence";
import MissingPunctuation from "../../components/ClassOne/English/MissingPunctuation";
import PunctuationWorksheet from "../../components/ClassOne/English/RewriteParagraph";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/punctuation/missing-punctuation", title: "Missing Punctuation", component: MissingPunctuation },
    { url: "/class-one/english/punctuation/identify-the-correct", title: "Identify the Correct", component: IdentifyCorrectSentence },
    { url: "/class-one/english/punctuation/rewrite-the-paragraph", title: "Rewrite the Paragraph", component: PunctuationWorksheet },
];


export default topics;